module.exports = __webpack_public_path__ + "img/start1.e3a731f6.jpg";